import React, { Component } from 'react'
import PropTypes from "prop-types";
import BaseMessageLayout from './BaseMessageLayout'

class AvailabilityChangedMessage extends Component {
    static  propTypes ={
        idconversation: PropTypes.number,
        textmessage: PropTypes.string,
        resource: PropTypes.string,
        type: PropTypes.string,
        messagedate: PropTypes.string,
        originusermessage:PropTypes.string,
        username:PropTypes.string,

    }

    render() {
        const { idconversation, textmessage, resource, type, messagedate, hours, minutes, username, originusermessage} = this.props
        return (
            <BaseMessageLayout
                messagedate={messagedate}
                hours={hours}
                minutes={minutes}
                resource={resource}
                type={type}
                originname={this.props.originname}
                displayoriginname={this.props.displayoriginname}
                >
                <p class="mb-0">
                    This material's general availability has changed. They are no longer a match with you at this time.
                </p>
            </BaseMessageLayout>
        )
    }
}

export default AvailabilityChangedMessage


